import CustomElement from '../core/custom.js'
import Emitter from '../core/emitter.js'
import Viewport from '../stores/viewport.js'
import getOffsetTop from '../utilities/getOffsetTop.js'
import { easeInOutQuad } from '../utilities/easings.js'
import App from '../stores/app.js'
import { preload } from '../utilities/preload.js'

export default window.customElements.define(
  'resource-nav',
  class extends CustomElement {
    isLg = false
    active = false

    constructor() {
      super()

      this.events = {
        'click .js-resource-nav-panel': 'onClickPanel',
        'click .js-link': 'onClickLink'
      }

      this._chapters = []
      this._currentItem = -1

      this._onResize = this.onResize.bind(this)
      this._onUpdate = this.onUpdate.bind(this)
      this._closePanel = this.closePanel.bind(this)
    }

    connectedCallback() {
      super.connectedCallback()

      this.$panel = this.querySelector('.js-resource-nav-panel')
      this.$links = Array.from(this.querySelectorAll('.js-link'))

      const main = this.closest('main')
      if (!main) return
      this.$chapters = Array.from(main.querySelectorAll('.js-resource-chapter'))

      this.resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.contentRect) {
            this._onResize()

            console.log(entry)
          }
        })
      })

      this.$chapters.forEach((el) => {
        this._chapters.push({
          el: el,
          offset: 0
        })

        this.resizeObserver.observe(el)
      })

      // Emitter.on('resize', this._onResize)
      Emitter.on('update', this._onUpdate)

      this._onResize()
      this.onItemChange()

      preload(
        Array.from(this.querySelectorAll('img')).map(
          (el) => el.currentSrc || el.src
        )
      ).then(this._onResize)
    }

    disconnectedCallback() {
      super.disconnectedCallback()

      // Emitter.off('resize', this._onResize)
      Emitter.off('update', this._onUpdate)

      document.body.removeEventListener('click', this._closePanel, {
        capture: true,
        once: true
      })

      this.resizeObserver.disconnect()
    }

    onResize() {
      this._chapters.forEach((item, i) => {
        item.offset = getOffsetTop(item.el) - Viewport.height / 2
      })
    }

    onBreakpoint({ matches }) {
      this.isLg = matches
      this.isLg && this.setData({ active: false })
    }

    onUpdate() {
      this._chapters.forEach((item, i) => {
        const nextOffset = this._chapters[i + 1]
          ? this._chapters[i + 1].offset
          : Number.MAX_SAFE_INTEGER

        if (
          window.scrollY >= item.offset &&
          window.scrollY < nextOffset &&
          this._currentItem !== i
        ) {
          this._currentItem = i
          this.onItemChange()
        }
      })
    }

    onItemChange() {
      this.$links.forEach((el, i) => {
        if (i === this._currentItem) {
          el.classList.add('is-active')
          !this.isLg && this.transformTo(i)
        } else {
          el.classList.remove('is-active')
        }
      })
    }

    transformTo(index) {
      this._translateY = (this.$links.length - index) * 22
      this.$panel.style.transform = `matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, ${this._translateY}, 0, 1)`
    }

    onClickPanel(event) {
      event.preventDefault()
      if (this.isLg) return

      this.setData({ active: !this.active })

      requestAnimationFrame(() => {
        if (this.active) {
          document.body.addEventListener('click', this._closePanel, {
            once: true
          })
        }
      })
    }

    closePanel() {
      this.setData({ active: false })
    }

    onClickLink(event) {
      event.preventDefault()

      // prevent link to chapter if mobile version and not opened
      if (!this.isLg && !this.active) return

      event.stopPropagation()
      this.closePanel()

      const target = document.getElementById(
        event.currentTarget.getAttribute('href').substr(1)
      )

      App.lenis.scrollTo(target, {
        duration: 0.8,
        easing: easeInOutQuad
      })
    }
  }
)
